import axios from 'axios'
import { config } from '../../config'
import { APP_CONSTANTS } from '../../utils/AppConstants'
import API_ENDPOINTS from './endpoints'

export function addMerchantAPI(payload) {
    const user = JSON.parse(sessionStorage.getItem(APP_CONSTANTS.USER))
    return axios.request({
        method: 'post',
        url: `${config.baseUrl}/${API_ENDPOINTS.merchant.addRecord}`,
        data: payload,
        headers: {
            'authToken': user.authToken
        }
    })
}

export function merchantListAPI(payload) {
    const user = JSON.parse(sessionStorage.getItem(APP_CONSTANTS.USER))
    return axios.request({
        method: 'get',
        url: `${config.baseUrl}/${API_ENDPOINTS.merchant.list}`,
        params: payload,
        headers: {
            'authToken': user.authToken
        }
    })
}
export function merchantDetailAPI(payload) {
    const user = JSON.parse(sessionStorage.getItem(APP_CONSTANTS.USER))
    return axios.request({
        method: 'get',
        url: `${config.baseUrl}/${API_ENDPOINTS.merchant.detail}/${payload}`,
        headers: {
            'authToken': user.authToken
        }
    })
}
export function updateMerchantDetailAPI(payload) {
    const user = JSON.parse(sessionStorage.getItem(APP_CONSTANTS.USER))
    return axios.request({
        method: 'put',
        url: `${config.baseUrl}/${API_ENDPOINTS.merchant.updateDetails}`,
        data: payload,
        headers: {
            'authToken': user.authToken
        }
    })
}